import React from "react";

export const ExitArrowIcon = ({ size = 16, color = "#1E22FF" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.63158 5.2L10.5789 8M10.5789 8L7.63158 10.8M10.5789 8H1M1.24892 4.5C2.52296 2.40769 4.90422 1 7.63158 1C11.701 1 15 4.13401 15 8C15 11.866 11.701 15 7.63158 15C4.90422 15 2.52296 13.5923 1.24892 11.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
